<style lang="less" scoped>
.box{
  &__search{
    width: 100%;
    padding: 0;
    .van-search__content--round{
      border-radius: 8px;
    }
  }

  &__list{
    width: 100%;
    &__row{
      position: relative;
      margin-top: 24px;
      &__rank{
        width: 22px;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        font-family: number-bold;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #2877FF;
      }
      &__top{
        padding: 8px 22px 0;
        display: flex;
        flex-direction: row;
        &__image{
          width: 56px;
          height: 56px;
          border: 1px solid #F6F6F6;
          box-sizing: border-box;
          border-radius: 8px;
          margin-right: 8px;
        }
        &__info{
          &__title{
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            color: #141B27;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
          }
          &__shop-box{
            margin-top: 4px;
            display: flex;
            flex-direction: row;
            align-items: center;
            &__shop-icon{
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
            &__shop-name{
              font-family: PingFang SC;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 12px;
              color: #141B27;
            }
          }
        }
      }
      &__bottom{
        margin-top: 12px;
        background: #FBFAFA;
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        &__item{
          padding: 12px 0;
          flex: 1;
          &__title{
            width: 100%;
            font-family: PingFang SC;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 12px;
            /* identical to box height, or 100% */
            text-align: center;
            color: #A1A4A9;
          }
          &__value{
            position: relative;
            margin-top: 8px;
            width: 100%;
            font-family: number-bold;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 14px;
            text-align: center;
            color: #141B27;
          }
          &__focus{
            color: #FF5000;
          }
          &__icon{
            position: absolute;
            width: 16px;
            height: 16px;
            top: -1px;
            left: 53px;
          }
        }
      }
    }
  }

  &__action-sheet{
    background: #ffffff;
  }
}
</style>
<template>
  <div class="box">
    <van-search v-model="inputModel" class="box__search" placeholder="请输入商品名称关键词" shape="round" @search="search" @clear="search"/>
    <van-list v-if="list.length" class="box__list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getTableData" >
      <div class="box__list__row" v-for="(item,index) of list" :key="index">
        <div class="box__list__row__rank">{{ index + 1 }}</div>
        <!--     上部分-->
        <router-link :to="item.goodsLink" class="box__list__row__top">
          <img :src="item.goodsImage" class="box__list__row__top__image">
          <div class="box__list__row__top__info">
            <div class="box__list__row__top__info__title">{{ item.goodsName }}</div>
            <div class="box__list__row__top__info__shop-box">
               <ShopIcon :shop-type="item.sourceType" is-number-sign class="box__list__row__top__info__shop-box__shop-icon"/>
              <div class="box__list__row__top__info__shop-box__shop-name">{{ item.shopName }}</div>
            </div>
          </div>
        </router-link>
        <!--     下部分   -->
        <div class="box__list__row__bottom">
          <div class="box__list__row__bottom__item" @click="showRelativeActionSheet(item.goodsId)">
            <div class="box__list__row__bottom__item__title">关联场次</div>
            <div class="box__list__row__bottom__item__value">
              {{ item.liveCount }}
              <img src="https://s6.bihukankan.com/img/1646033041Group 4123.svg" class="box__list__row__bottom__item__icon">
            </div>
          </div>
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">直播价格</div>
            <div class="box__list__row__bottom__item__value">{{ item.price }}</div>
          </div>
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">销量</div>
            <div class="box__list__row__bottom__item__value">{{ item.salesVolume }}</div>
          </div>
          <div class="box__list__row__bottom__item">
            <div class="box__list__row__bottom__item__title">销售额</div>
            <div class="box__list__row__bottom__item__value box__list__row__bottom__item__focus">{{ item.sales }}</div>
          </div>
        </div>
      </div>
    </van-list>
    <NoneData v-else propsText="该主播在所选时间范围内没有卖货" :height="5" :imgSize="1.65"/>

  <!--    弹窗-->
    <van-action-sheet v-model="show" title="关联直播" class="box__action-sheet">
      <relative-live-list :time="time" :show="show" :goods-id="goodsId"/>
    </van-action-sheet>
  </div>
</template>
<script>
import RelativeLiveList from "@/modules/anchor/ShopAnalysis/RelativeLiveList";
export default {
  components:{ RelativeLiveList },
  props:{
    time:{ type:Array, default: () => ([]) }, // 时间参数
  },
  data:() => ({
    goodsId: null,
    show:false, // 展示底部弹窗
    loading:true,
    listApiData:{},
    inputModel:'', // 输入框
    q: null, // 实际参数
    listParams:{ // 列表参数
      pageNum:1,
      pageSize:25,
      order:'desc',
      sort:'sales'
    }
  }),
  watch:{
    time:{
      immediate:true,
      handler(){
        this.listParams.pageNum = 1
        this.getTableData()
      }
    }
  },
  computed:{
    params:(_this = this) => ({
      time:`$between:[${_this.time[0]},${_this.time[1]}]`,
      q: _this.q,
      ..._this.listParams
    }),
    list:(_this = this) => ( _this.listApiData?.data?.map((ele,index) => ({
      goodsId:ele?.itemId? ele.itemId : null,
      goodsName: ele?.commodity || '-', // 商品名称
      goodsImage: ele?.platformImageUrl || _this.$defaultSrc, // 商品图片
      shopName: ele?.shop?.name? ele?.shop?.name :  ele?.sourceType === 2 ?  '淘宝店铺' : '未知店铺', // 店铺名称
      shopIcon: ele?.sourceType || 2, // 店铺标识
      brandName: ele?.brand?.name || '未知品牌', // 品牌名称
      brandLink: ele?.brand?.id? `/brand/${ele.brand.id}/sell` : null , // 品牌链接
      brandIcon: ele?.brand?.image || _this.$defaultSrc, // 品牌图片
      liveCount: ele?.liveStreamCount ? _this.$retainWan(ele.liveStreamCount) :'-', // 关联场次
      price: ele?.price? '¥' + _this.$retainWan(ele.price) : '-', // 商品价格
      salesVolume: ele?.salesVolume? _this.$retainWan(ele.salesVolume) : '-', // 销量
      sales: ( Number(ele?.price) && Number(ele?.salesVolume) && !Number(ele?.sales)) ? '未列入统计' : String(ele.sales) ? '¥' +  _this.$retainWan(ele.sales) : '-', // 销售额
      goodsLink: ele?.itemId ? `/goods/${ele.itemId}` : '' , // 商品链接 // 内部
    })) || []),
    finished:(_this = this) => (_this.listApiData?.paging?.count || 0) === (_this.list.length || 0)
  },
  methods:{
    /** 输入框输入数据 */
    search(event){
      if(typeof event === 'string' || typeof event === 'number'){
        this.q = event
      }else{
        this.q = ''
      }
      this.listParams.pageNum = 1
      this.getTableData()
    },
    /** 获取商品数据 */
    async getTableData() {
      this.loading = true
      this.inputModel = this.q // 恢复搜索展示
      this.listApiData = await this.$api.get(`/v2/anchor/${this.$route.params.id}/liveStreamCommodity`, {params: this.params})
          .then(_ =>{
            this.listParams.pageNum ++
            return this.listParams.pageNum - 1 > 1 ? { paging: _?.data?.paging, data: [...this.listApiData.data, ..._?.data?.data] } :_?.data || {}
          })
          .catch(_ => ( this.listApiData ))
      this.loading = false
    },
    /** 展示弹窗 */
    showRelativeActionSheet(event){
      this.goodsId = event
      this.show = true
    }
  }
}
</script>